// creditosSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CreditApi from '../api/credit/credit.ts';

export const fetchCreditsAsync = createAsyncThunk(
  'credit/fetchCredits',
  async (customer_id) => {
    const response = await CreditApi(customer_id);
    return response;
  }
);

const creditSlice = createSlice({
  name: 'credits',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCreditsAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCreditsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCreditsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default creditSlice.reducer;
